import type { ApiAccount } from './api.js';


const SEQUENCE_WIDTH = 4;

const MAX_LEVEL = 5;

function nextNumber(parentCode: string, taken: ReadonlySet<string>): number {
  const prefix = `${parentCode}-`;
  let highest = 0;
  for (const code of taken) {
    if (!code.startsWith(prefix)) continue;
    const tail = code.slice(prefix.length);
    if (tail.includes('-')) continue;
    if (!/^\d+$/.test(tail)) continue;
    highest = Math.max(highest, Number(tail));
  }
  return highest + 1;
}

export function nextAccountCode(
  parent: ApiAccount | undefined,
  accounts: readonly ApiAccount[],
): string {
  const taken = new Set(accounts.map((account) => account.code));

  if (!parent) {
    let next = 1;
    while (taken.has(String(next))) next += 1;
    return String(next);
  }

  if (parent.level >= MAX_LEVEL) return '';

  const level = parent.level + 1;
  const n = nextNumber(parent.code, taken);
  return level >= MAX_LEVEL
    ? `${parent.code}-${String(n).padStart(SEQUENCE_WIDTH, '0')}`
    : `${parent.code}-${n}`;
}
